var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pl-6"},[_c('div',{staticClass:"text-sm font-semibold text-white"},[_vm._v("\n    Blog\n  ")]),_vm._v(" "),_c('nav',{staticClass:"mt-8"},[_c('ul',{staticClass:"space-y-3"},[_c('LinkGroup',{attrs:{"parent":{
          text: 'Motion Array',
          link: '/learn/motion-array/',
          target: '_blank'
        },"children":[
          {
            text: 'Tutorials',
            link: '/learn/motion-array/tutorials/',
            target: '_blank'
          },
          {
            text: 'Resources',
            link: '/learn/motion-array/resources/',
            target: '_blank'
          },
          {
            text: 'News',
            link: '/learn/motion-array/news/',
            target: '_blank'
          } ]}}),_vm._v(" "),_c('LinkGroup',{attrs:{"parent":{
          text: 'After Effects',
          link: '/learn/after-effects/',
          target: '_blank'
        },"children":[
          {
            text: 'Tutorials',
            link: '/learn/after-effects/tutorials/',
            target: '_blank'
          },
          {
            text: 'Resources',
            link: '/learn/after-effects/resources/',
            target: '_blank'
          },
          {
            text: 'News',
            link: '/learn/after-effects/news/',
            target: '_blank'
          },
          {
            text: 'Troubleshooting',
            link: '/learn/after-effects/troubleshooting/',
            target: '_blank'
          } ]}}),_vm._v(" "),_c('LinkGroup',{attrs:{"parent":{
          text: 'Premiere Pro',
          link: '/learn/premiere-pro/',
          target: '_blank'
        },"children":[
          {
            text: 'Tutorials',
            link: '/learn/premiere-pro/tutorials/',
            target: '_blank'
          },
          {
            text: 'Resources',
            link: '/learn/premiere-pro/resources/',
            target: '_blank'
          },
          {
            text: 'News',
            link: '/learn/premiere-pro/news/',
            target: '_blank'
          },
          {
            text: 'Troubleshooting',
            link: '/learn/premiere-pro/troubleshooting/',
            target: '_blank'
          } ]}}),_vm._v(" "),_c('LinkGroup',{attrs:{"parent":{
          text: 'DaVinci Resolve',
          link: '/learn/davinci-resolve/',
          target: '_blank'
        },"children":[
          {
            text: 'Tutorials',
            link: '/learn/davinci-resolve/tutorials/',
            target: '_blank'
          },
          {
            text: 'Resources',
            link: '/learn/davinci-resolve/resources/',
            target: '_blank'
          },
          {
            text: 'News',
            link: '/learn/davinci-resolve/news/',
            target: '_blank'
          },
          {
            text: 'Troubleshooting',
            link: '/learn/davinci-resolve/troubleshooting/',
            target: '_blank'
          } ]}}),_vm._v(" "),_c('LinkGroup',{attrs:{"parent":{
          text: 'Final Cut Pro',
          link: '/learn/final-cut-pro/',
          target: '_blank'
        },"children":[
          {
            text: 'Tutorials',
            link: '/learn/final-cut-pro/tutorials/',
            target: '_blank'
          },
          {
            text: 'Resources',
            link: '/learn/final-cut-pro/resources/',
            target: '_blank'
          },
          {
            text: 'News',
            link: '/learn/final-cut-pro/news/',
            target: '_blank'
          },
          {
            text: 'Troubleshooting',
            link: '/learn/final-cut-pro/troubleshooting/',
            target: '_blank'
          } ]}}),_vm._v(" "),_c('LinkGroup',{attrs:{"parent":{
          text: 'Filmmaking',
          link: '/learn/filmmaking/',
          target: '_blank'
        },"children":[
          {
            text: 'Tutorials',
            link: '/learn/filmmaking/tutorials/',
            target: '_blank'
          },
          {
            text: 'Resources',
            link: '/learn/filmmaking/resources/',
            target: '_blank'
          },
          {
            text: 'News',
            link: '/learn/filmmaking/news/',
            target: '_blank'
          } ]}}),_vm._v(" "),_c('LinkGroup',{attrs:{"parent":{
          text: 'Motion Design',
          link: '/learn/motion-design/',
          target: '_blank'
        },"children":[
          {
            text: 'Tutorials',
            link: '/learn/motion-design/tutorials/',
            target: '_blank'
          },
          {
            text: 'Resources',
            link: '/learn/motion-design/resources/',
            target: '_blank'
          },
          {
            text: 'News',
            link: '/learn/motion-design/news/',
            target: '_blank'
          } ]}}),_vm._v(" "),_c('LinkGroup',{attrs:{"parent":{
          text: 'Post Production',
          link: '/learn/post-production/',
          target: '_blank'
        },"children":[
          {
            text: 'Tutorials',
            link: '/learn/post-production/tutorials/',
            target: '_blank'
          },
          {
            text: 'Resources',
            link: '/learn/post-production/resources/',
            target: '_blank'
          },
          {
            text: 'News',
            link: '/learn/post-production/news/',
            target: '_blank'
          } ]}}),_vm._v(" "),_c('LinkGroup',{attrs:{"parent":{
          text: 'Music',
          link: '/learn/royalty-free-music/',
          target: '_blank'
        },"children":[
          {
            text: 'Tutorials',
            link: '/learn/royalty-free-music/tutorials/',
            target: '_blank'
          },
          {
            text: 'Resources',
            link: '/learn/royalty-free-music/resources/',
            target: '_blank'
          } ]}}),_vm._v(" "),_c('LinkGroup',{attrs:{"parent":{
          text: 'Video Effects',
          link: '/learn/video-effects/',
          target: '_blank'
        },"children":[
          {
            text: 'Tutorials',
            link: '/learn/video-effects/tutorials/',
            target: '_blank'
          },
          {
            text: 'Resources',
            link: '/learn/video-effects/resources/',
            target: '_blank'
          } ]}})],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }